import { Slider as MantineSlider } from '@mantine/core';

export const Slider = MantineSlider.extend({
	defaultProps: {
		label: null,
	},
});
